import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@core/environments/environment';
import { ApiClient } from '@core/http/api-client';
import { ResponseUrls } from '@core/interfaces/interfaces';

@Injectable({
	providedIn: 'root',
})
export class UploadApi {
	private storageS3Url = environment.URL_STORAGE_S3;

	constructor(
		private readonly api: ApiClient,
		private readonly http: HttpClient,
	) {}

	uploadImages(
		bucketName: string,
		userId: string,
		farmId: string,
		subBucketName: string[],
		uploadTimeSeconds?: number,
		dataLevantamento?: string | null,
		modoDev?: boolean,
	): Observable<any> {
		return this.api.post<any>('/image4k/uploadImages', {
			bucketName,
			userId,
			farmId,
			subBucketName,
			uploadTimeSeconds,
			dataLevantamento,
			modoDev,
		});
	}

	/** Pede ao worker para parar o job: pelo bucket do upload ou pelo idFolder da linha. */
	cancelProcessing(target: { bucketName?: string; idFolder?: string }): Observable<any> {
		return this.api.post<any>('/image4k/cancelProcessing', target);
	}

	createBucket(bucketName: string): Observable<any> {
		return this.api.post('/image4k/createBucketIfNotExists', {
			bucketName,
		});
	}

	getUrls(farm: string, folder: string, user: string): Observable<any> {
		return this.api.get(`/cow/getImages/${farm}/${folder}/${user}`);
	}

	getRequisicoesFeitasV2(userId: string, farmId: string): Observable<any> {
		return this.api.get(`/cow/getHistorico/${userId}/${farmId}`);
	}

	private normalizeImageUrlForBrowser(url: string): string {

		if (/^https?:\/\/localhost(?::\d+)?(\/|$)/i.test(url)) {
			try {
				const parsed = new URL(url);
				url = `${this.storageS3Url}${parsed.pathname}`;
			} catch {
				url = url.replace(
					/^https?:\/\/localhost(?::\d+)?/i,
					this.storageS3Url,
				);
			}
		}

		if (/^https?:\/\/seaweedfs(\/|:|$)/i.test(url)) {
			try {
				const parsed = new URL(url);
				url = `${this.storageS3Url}${parsed.pathname}`;
			} catch {

				url = url.replace(
					/^https?:\/\/seaweedfs(?::\d+)?/i,
					this.storageS3Url,
				);
			}
		}

		if (
			typeof window !== 'undefined' &&
			window.location.protocol === 'https:' &&
			url.startsWith('http://')
		) {
			url = url.replace('http://', 'https://');

			url = url.replace(':8333', '');
		}
		return url;
	}

	downloadImageStorage(url: string): Observable<Blob> {
		const safeUrl = this.normalizeImageUrlForBrowser(url);
		return this.http.get(safeUrl, { responseType: 'blob' });
	}

	uploadImageStorage(file: File, presignedUrl: string): Observable<any> {
		return this.http.put(presignedUrl, file, {
			responseType: 'text' as 'json',
		});
	}

	uploadFileDiretoAngular(
		bucketName: string,
		file: File,
		subBucketName?: string,
	): Observable<any> {

		const fileName = `${Date.now()}-${file.name}`;

		const path = subBucketName ? `${subBucketName}/${fileName}` : fileName;

		const url = `${this.storageS3Url}/${bucketName}/${path}`;

		const headers = new HttpHeaders({
			'Content-Type': file.type || 'application/octet-stream',
		});

		return this.http.put(url, file, {
			headers,
			reportProgress: true,
			observe: 'events',
		});
	}

	getUrlFromStorage(
		fileNames: string[],
		bucketName: string,
		subBucketName: string,
	): Observable<ResponseUrls> {
		return this.api.post<ResponseUrls>('/image4k/getUrlFromStorage', {
			fileNames,
			bucketName,
			subBucketName,
		});
	}

}
